var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(this.params.icon)?_c('hb-icon',[_vm._v(_vm._s(_vm.icon))]):[_vm._v(_vm._s(_vm.statusText))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }